import { useEffect, useState } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { getMemberData, lookupMembershipData } from '../lib/services'
import { membershipDataMunge } from '../lib/mungers'

export default function useCompareUuids(dispatch) {
  const { query } = useQueryParams()
  const [isSameAccount, setIsSameAccount] = useState(undefined)
  const { token } = query ?? {}

  useEffect(() => {
    const compareUuids = async () => {
      if (token) {
        let proxyMemberInfo = null
        let signedinMemberData = null

        try {
          let response = await lookupMembershipData(token)
          proxyMemberInfo = response?.data
          dispatch({ type: 'SET_MEMBERSHIP_INFO', membershipInfo: membershipDataMunge(proxyMemberInfo ?? {}) })

          try {
            response = await getMemberData()
            signedinMemberData = response?.data

            if (proxyMemberInfo && signedinMemberData) {
              setIsSameAccount(proxyMemberInfo?.personUuid === signedinMemberData?.personUuid)
            }
          } catch (error) {
            // NOTE: if the error response is a 404 then there is no membership record for the currently signed in user and we don't need to compare uuids
            if (error?.response?.status !== 404) {
              dispatch({
                type: 'SET_ERROR_TYPE',
                errorType: error?.response?.status >= 500 ? 'SYSTEM_DOWN' : 'READ_MEMBERSHIP_INFO',
              })
            } else {
              setIsSameAccount(false)
            }
          }
        } catch (error) {
          dispatch({
            type: 'SET_ERROR_TYPE',
            errorType: error?.response?.status >= 500 ? 'SYSTEM_DOWN' : 'READ_MEMBERSHIP_INFO',
          })
        }
      } else {
        // If there is no token, we'll want to return true to not prevent redirection logic.
        setIsSameAccount(true)
      }
    }
    compareUuids()
  }, [dispatch, token])

  return isSameAccount
}
